import React from 'react'

export default function ComingSoon() {
  return(
    <p align="center"><img src="/static/images/coming-soon.png" alt="Coming soon" title="Coming soon" /></p>
  )
}
